export const PUT_PROFILE_WATCHER = 'PUT_PROFILE_WATCHER';
export const PUT_PROFILE_SUCCESS = 'PUT_PROFILE_SUCCESS';
export const PUT_PROFILE_FAILED = 'PUT_PROFILE_FAILED';
